import { IconProps } from "../type";

const ArrowUpIcon = ({ width, height, color }: IconProps) => {
    return (
        <svg
            width={width ? width : "14"}
            height={height ? height : "8"}
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path 
            d="M1 7L7 1L13 7" 
            stroke={color ? color : "#2E2E2E"}
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round" />
        </svg>

    );
}

export default ArrowUpIcon;